"use client";

import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import useLogin from "../../hooks/useLogin";
import { closeLoading, openLoading } from "../loadingModal/loading";
import Loading from "../loadingModal/LoadingModal";
import DocLayout from "../DocLayout";
import BackgroundLayout from "../BackgroundLayout";

const ProtectedRoute = ({ children }) => {
  const { confirmIsAuth, loggedUser } = useLogin();
  const [authStatus, setAuthStatus] = useState("checking"); // "checking", "authorized", "unauthorized"

  useEffect(() => {
    openLoading();
    const token = localStorage.getItem("token");

    if (!token) {
      setAuthStatus("unauthorized");
      return;
    }

    confirmIsAuth()
      .then(() => {
        setAuthStatus("authorized");
        closeLoading();
      })
      .catch(() => {
        setAuthStatus("unauthorized");
      });
  }, []);
  if (authStatus === "authorized") return <>{children}</>;
  if (authStatus === "unauthorized") return <Navigate to="/login" replace />;
  if (authStatus === "checking")
    return (
      <>
        <Loading />
        {loggedUser.isLogged ? (
          children
        ) : (
          <>
            <BackgroundLayout />
          </>
        )}
      </>
    );
  return <>{children}</>;
};

export default ProtectedRoute;
